import { PatientPortalEmailControllerApi } from "../../services";
import { getConfigObject, getXtenantId, useMutationWithLoading } from "../../utils/utils";

interface Params {
  emailUuid: string;
}

export const usePatientPortalEmailMarkAsRead = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientPortalEmailControllerApi(getConfigObject()).markEmailAsRead(
      params.emailUuid,
      getXtenantId()
    )
  );
